<template>
  <div class="psConfigurationWeeklyTracking">
    <ps-upper-bar :site="{ site: 'Configuración - Conceptos' }" :backButton="true"></ps-upper-bar>
    <div class="container">
      <div class="row">
        <el-button round plain icon="el-icon-plus" @click="addWeeklyTracking" :disabled="newWeeklyTracking">Nueva columna</el-button>
      </div>
      <div class="row rowData">
        <div class="column w-25">
          <div class="label">Título</div>
          <el-input 
            :value="weeklyTracking.title" 
            @input="changeProperty($event, 'title')" 
            placeholder="Ingrese un título"
            :disabled="!newWeeklyTracking"></el-input>
        </div>
        <div class="column w-25">
          <div class="label">Subtítulo</div>
          <el-input 
            :value="weeklyTracking.subtitle" 
            @input="changeProperty($event, 'subtitle')" 
            placeholder="Ingrese un subtítulo"
            :disabled="!newWeeklyTracking"></el-input>
        </div>
        <div class="column w-10">
          <div class="label">Orden</div>
          <el-input-number 
            style="width: 100%"
            :value="weeklyTracking.order" 
            @input="changeProperty($event, 'order')" 
            placeholder="Ingrese un orden"
            :min="1"
            :controls="false"
            :disabled="!newWeeklyTracking"></el-input-number>
        </div>
        <div class="column w-10">
          <div class="label">Activa</div>
          <el-switch :value="weeklyTracking.active" @input="changeProperty($event, 'active')" :disabled="!newWeeklyTracking"></el-switch>
        </div>
      </div>
      <div class="row rowButtons">
        <el-button round plain type="success" :disabled="!saveDisabled" @click="save">Guardar</el-button>
        <el-button round plain type="danger" :disabled="!newWeeklyTracking" @click="cancelWeeklyTracking">Cancelar</el-button>
      </div>

      <el-table 
        :data="weeklyTrackings"
        style="width: 800px;" 
        :highlight-current-row="true" 
        size="mini" 
        height="300" 
        empty-text="No hay columnas ingresados"
        @cell-dblclick="selectRow">
        <el-table-column prop="id" label="Código" width="80" class-name="conceptId" id="conceptId" v-if="!isMobile"></el-table-column>
        <el-table-column prop="title" label="Título" :width="isMobile == true ? '' : 200" ></el-table-column>
        <el-table-column prop="subtitle" label="Subtítulo" :width="isMobile == true ? '' : 200" ></el-table-column>
        <el-table-column prop="order" label="Orden" :width="isMobile == true ? '' : 200" ></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import PsUpperBar from '@/components/layout/PsUpperBar.vue'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'PsConfigurationWeeklyTracking',
  components: { PsUpperBar },
  data () {
    return {
      newWeeklyTracking: false
    }
  },
  computed: {
    ...mapState(['isMobile']),
    ...mapState('weeklyTracking', ['weeklyTrackings', 'weeklyTracking', 'errors']),
    saveDisabled () {
      return this.newWeeklyTracking && this.weeklyTracking.title != '' 
    }
  },
  methods: {
    ...mapMutations('weeklyTracking', ['WEEKLY_TRACKING_WEEKLY_TRACKING', 'WEEKLY_TRACKING_WEEKLY_TRACKING_PROP']),
    ...mapActions('weeklyTracking', ['saveWeeklyTracking', 'getWeeklyTrackingsHTTP']),
    selectRow ( row ) {
      if( row ) {
        this.newWeeklyTracking = true
        this.WEEKLY_TRACKING_WEEKLY_TRACKING(JSON.parse(JSON.stringify(row)))
      }
    },
    changeProperty ( value, property ) {
      this.WEEKLY_TRACKING_WEEKLY_TRACKING_PROP({property, value})
    },
    addWeeklyTracking () {
      this.newWeeklyTracking = true
      this.WEEKLY_TRACKING_WEEKLY_TRACKING({})
    },
    cancelWeeklyTracking () {
      this.newWeeklyTracking = false
      this.WEEKLY_TRACKING_WEEKLY_TRACKING({})
    },
    async save () {
      let loading
      try {
        loading = this.$loading({
          lock: true,
          text: 'Guardando...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        }); 

        const message = await this.saveWeeklyTracking()
        if(this.errors.length > 0 ) {
          this.showValidationAlert()
        } else {
          this.cancelWeeklyTracking()
          this.$message( { message, type: 'success' } )
          this.getWeeklyTrackingsHTTP()
        }
    } catch ( err ) { this.$message( { message: err.response.data.err.details, type: 'error' })}
      finally { loading.close(); }
    },
    showValidationAlert () {      
      let str = '<p>';
      if(this.errors.length > 0) {
        this.errors.forEach(err => str += `${err}<br>`)
        str = str + '</p>'
        this.$alert(str, '', {confirmButtonText: 'Entendido', type: 'warning', dangerouslyUseHTMLString: true})
      }
    },
  },
  created () {
    this.WEEKLY_TRACKING_WEEKLY_TRACKING({})
    this.getWeeklyTrackingsHTTP()
  }
}
</script>

<style scoped>
  .psConfigurationWeeklyTracking { min-height: 90%;}
  .container { background-color: white; border-radius: 20px; padding: 32px; min-height: 90%; overflow-y: scroll; height: 100%; }
  .container::-webkit-scrollbar { display: none}
  .rowData { margin: 40px 0 20px}
  .rowHistory { margin-bottom: 20px;}
  .el-collapse { width: 500px }
  .itemHistoryRate { text-align: left;}
  .stateRate { color: red; margin-left: 15px}
  .active { color: green}


  /* Medium devices (tablets, less than 992px) */
  @media (max-width: 991.98px) {
    .container { padding: 32px 16px}
    .rowData { flex-direction: column;}
    .rowData .column { margin-right: 0 }
    .rowData .column .el-input-number, .rowData .w-25 { width: 100%; margin-bottom: 8px; }
    .rowButtons { justify-content: space-evenly;}
  }
</style>